
import { PropType, defineComponent } from 'vue'

import DropDownComponent from './../form/DropDownComponent.vue'

export interface PlanAffiliationFormState {
  value: string
  title: string
  plans: unknown[] | null
  planType: string
  clientOptions: unknown[]
}

export default defineComponent({
  name: 'plan-affiliations-form',
  components: {
    DropDownComponent
  },
  props: {
    planAffiliation: {
      type: Object as PropType<PlanAffiliationFormState>,
      required: true
    }
  }
})
